import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { string } from "yup";

export interface UserInfo {
  regId: number;
  username: string;
  registrationNo: string;
  organizationName: string;
  organizationType: string;
  city: string;
  address: string;
  phone: string;
  pincode: string;
  projectDescription: string;
  projectPurpose: string;
  quarterlyTransactionCount: number;
  serviceType: string;
  sacode:string;
  dept:string;
  ministry:string;
  set_password_flag:string
  aua_kua_code:string
  aua_kua_code_prod:string
}

interface UserState {
  user: UserInfo | null;
}

const initialState: UserState = {
  user: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserInfo>) {
      state.user = action.payload;
    },

    clearUser(state) {
      state.user = null;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;